//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data () {
    return {
      user: {
        userId: '',
        name: '',
        headurl: '',
        address: '',
        profession: '',
        subscribe: 0
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.user = vm.$store.state.sx.user || vm.user
      if (vm.$isWechat()) {
        vm.$wechatHideShare()
      }
    })
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/page/Service.vue